{
	"defaultDescription": "Analyzing photos to learn your editing style. This may take a few moments."
}
